<div fxLayout="column" mat-dialog-title>
  <span
    role="button"
    tabindex="0"
    class="material-icons inline-block closeBtn"
    (keyup.space)="closeButton()"
    (keyup.enter)="closeButton()"
    (click)="closeButton()"
    >close</span
  >
  <div class="titleContainer">
    <mat-label class="title"><h2 [id]="addressVerificationHeadingId">Address Verification</h2></mat-label>
    <img
      height="100%"
      src="{{ suggestedAddressRules.icon }}"
      alt="Address verification"
    />
  </div>
  <div class="infoContainer">
    <div class="addressContainer">
      <mat-label class="no-bottom-margin">
        <h3>Original Address</h3>
      </mat-label>
      <span data-dd-privacy="mask"
        >{{ inputtedAddress1 }} {{ inputtedAddress2 }}</span
      >
      <span class="no-bottom-margin" data-dd-privacy="mask"
        >{{ inputtedCity }}, {{ inputtedState }} {{ inputtedZip }}</span
      >
    </div>
    <div class="addressContainer">
      <mat-label class="no-bottom-margin">
        <h3>Suggested Address</h3>
      </mat-label>
      <span data-dd-privacy="mask"
        >{{ suggestedAddress1 }} {{ suggestedAddress2 }}</span
      >
      <span data-dd-privacy="mask"
        >{{ suggestedCity }}, {{ suggestedState }} {{ suggestedZip }}</span
      >
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutAlign="end center"
    fxLayoutGap="1em"
  >
    <button mat-stroked-button class="secondary-btn-action" color="primary" (click)="keepInputted()">
      Use Original Address
    </button>
    <button mat-flat-button class="primary-btn-action" color="primary" (click)="useSuggested()">
      Use Suggested Address
    </button>
  </div>
</div>
